"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _deepmerge = require("deepmerge");

var _reactlyticsProps = _interopRequireDefault(require("./reactlyticsProps"));

var _useReactlytics = _interopRequireDefault(require("./useReactlytics"));

var _ReactlyticsProvider = _interopRequireDefault(require("./ReactlyticsProvider"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/* eslint-disable react/require-default-props */
var ExtendReactlytics = function ExtendReactlytics(_ref) {
  var analytics = _ref.analytics,
      children = _ref.children;
  var oldAnalytics = (0, _useReactlytics.default)();
  var mergedAnalytics = (0, _react.useMemo)(function () {
    return (0, _deepmerge.all)([oldAnalytics, analytics || {}]);
  }, [oldAnalytics, analytics]);
  return _react.default.createElement(_ReactlyticsProvider.default, {
    analytics: mergedAnalytics
  }, children);
};

ExtendReactlytics.propTypes = {
  analytics: _reactlyticsProps.default.analytics.isRequired,
  children: _reactlyticsProps.default.children.isRequired
};

var _default = (0, _react.memo)(ExtendReactlytics);

exports.default = _default;